<div [ngClass]="mode === 'md' ? 'center-text' : ''">
  <ion-button [color]="color" [fill]="mode === 'ios' ? 'clear' : 'solid'">
    <app-icon *ngIf="icon && mode === 'md'" [name]="icon" slot="start"></app-icon>
    {{label}}
  </ion-button>
</div>
